import styled from 'styled-components';

export const AiBtnWhite = styled.button`
  padding: 10px 20px;
  background-color: rgba(255,255,255,0.5);
  border-radius: 5px;
  color: #000000;
  border: 1px solid #dedede;
  cursor: pointer;
  transition-duration: 200ms;
  &:hover {
    transition-duration: 200ms;
    background-color: rgba(23, 125, 214, 0.2);    
  }
`;

// pointer-events: none;
export const AiModalStyledTextArea = styled.textarea`
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
  border-color: rgb(204, 204, 204);
  
  resize:none;
  width: 400px;
  max-width: 400px;
  min-height: 200px;
  height: auto;
  max-height: 400px;
  overflow-y: scroll;

  &:focus {
    outline-color: transparent;
    outline-style: none;
  }
`;

export const AiModal = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 8px;
`;

export const AiModalHeader = styled.div`
  font-family: "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  color: #1D1D1F;
  padding-top: 4px;
  padding-bottom: 1px;
`;

export const AiModalBody = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
`;

export const AiModalFooter = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
`;